import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import { H2 } from 'UIComponents/elements/headings';
import styled, { theme } from 'academy-common-lib/utils/Styling';
import ToolRecommendationsForLearningContent from '../ToolRecommendationsForLearningContent';
import { useGetToolRecommendations } from '../../queries/softwareDiscoveryHooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ContainerWrapper = styled.div.withConfig({
  displayName: "ShortContentFullToolRecommendations__ContainerWrapper",
  componentId: "sc-16rkmvq-0"
})(["width:100%;height:100%;background-color:", ";padding-top:75px;padding-left:30px;padding-right:30px;"], theme.colors.FLAT_EARTH);
const TextWrapper = styled.div.withConfig({
  displayName: "ShortContentFullToolRecommendations__TextWrapper",
  componentId: "sc-16rkmvq-1"
})(["text-align:center;margin:0 100px 60px 100px;"]);
const CommonComponentContainer = styled.div.withConfig({
  displayName: "ShortContentFullToolRecommendations__CommonComponentContainer",
  componentId: "sc-16rkmvq-2"
})(["color:", ";margin-top:20px;margin-bottom:20px;"], theme.colors.OBSIDIAN);
const ShortContentFullToolRecommendations = ({
  contentName,
  useCases
}) => {
  const toolRecommendations = useGetToolRecommendations(useCases);
  if (!toolRecommendations) {
    return null;
  }
  const {
    recommendationTopic
  } = toolRecommendations;
  return /*#__PURE__*/_jsx(ContainerWrapper, {
    children: /*#__PURE__*/_jsx(ToolRecommendationsForLearningContent, {
      cardWidth: 250,
      contentName: contentName,
      renderRecommendations: commonContent => {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs(TextWrapper, {
            children: [/*#__PURE__*/_jsx(UIMediaObject, {
              align: "center",
              itemRight: /*#__PURE__*/_jsx(UIIcon, {
                color: theme.colors.SORBET,
                name: "sprocket",
                size: "md"
              }),
              spacing: "none",
              children: /*#__PURE__*/_jsx(H2, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "learningCenter.shortContent.fullScreenToolRecommendations.title"
                })
              })
            }), /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.shortContent.fullScreenToolRecommendations.description",
              options: {
                topic: recommendationTopic
              }
            })]
          }), /*#__PURE__*/_jsx(CommonComponentContainer, {
            children: commonContent
          })]
        });
      },
      toolsToDisplay: 3,
      useCases: useCases
    })
  });
};
export default ShortContentFullToolRecommendations;